import { frontendURL } from '../../../helper/URLHelper';
import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';

const saleOfferRoute = {
  path: frontendURL('accounts/:accountId/propostas/:offerId'),
  component: RentFlowsIndex,
};

export default saleOfferRoute;
